import axios from 'axios';
import AppConfig from "../../../AppConfig";

let URL = AppConfig.HOST_API() + 'orlenDane/'

export default {

    wyswietlDaneOrlen(params){
        return axios({
            method: 'get',
            url: URL+'search?dataOd='+params.dataOd+'&dataDo='+params.dataDo
        })
    },

    pobierzDaneOrlen(params){
        return axios({
            method: 'post',
            url: URL+'?dataOd='+params.dataOd+'&dataDo='+params.dataDo
        })
    },

    pobierzNumeryFaktur(){
        return axios({
            method: 'get',
            url: URL+'nrFaktur'
        })
    },

    pobierzPozycjeFaktury(nr){
        return axios({
            method: 'get',
            url: URL+'nrFaktury/?nrFaktury='+nr
        })
    },

    wyslijDaneFaktury(nrFaktury,netto){
        return axios({
            method: 'post',
            url: URL+'pWyslijFaktureOrlen',
            data: JSON.stringify({
                nrFaktury:nrFaktury,
                kwotaNetto:netto
            }),
            timeout: 60 * 5 * 1000
        })
    },

    pobierzRaportOrlen(params){
        return axios({
            method: 'get',
            url: URL+'pOrlenDaneRaport?dataOd='+params.dataOd+'&dataDo='+params.dataDo
        })
    },

}


// WEBPACK FOOTER //
// ./src/modules/raporty/Orlen/OrlenService.js